import { Component } from '@angular/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SecurityService } from './services/security.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent {

  constructor(private securityService: SecurityService) {
    // Forzar modo claro en toda la aplicación
    this.setupLightMode();
    this.securityService.restoreSession();
    this.registerSessionLifecycleListeners();
  }

  async setupLightMode() {
    // Establecer el tema claro en el documento
    document.body.classList.remove('dark');
    document.body.setAttribute('color-theme', 'light');
    
    // Configurar el status bar para modo claro (solo en dispositivos nativos)
    try {
      await StatusBar.setStyle({ style: Style.Light });
    } catch (error) {
      // No-op on unsupported platforms.
    }
  }

  private registerSessionLifecycleListeners() {
    App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) {
        return;
      }

      this.securityService.onAppForeground$().pipe(
        catchError(() => EMPTY)
      ).subscribe();
    });

    window.addEventListener('online', () => {
      this.securityService.onConnectivityRestored$().pipe(
        catchError(() => EMPTY)
      ).subscribe();
    });
  }

}
